module.exports = __webpack_public_path__ + "static/media/Products (11).e3c0b091.png";